import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';

import { navigationDataAdapterMethodsFactory } from './navigation.data-adapter-methods';
import { navigationFeatureMethodsFactory } from './navigation.feature-methods';
import { navigationHooksFactory } from './navigation.hooks';
import { NavigationPositionItem } from '../models/navigation-position-item.type';
import { NavigationProductItem } from '../models/navigation-product-item.type';
import { navigationReductionMethodsFactory } from './navigation.reduction-methods';

export type NavigationState = {
  hiddenOnHandset: boolean;
  positionsMap: Map<NavigationProductItem['application'], NavigationPositionItem[]>;
  products: NavigationProductItem[];
};

const initialState: NavigationState = {
  hiddenOnHandset: true,
  positionsMap: new Map(),
  products: [],
};

export const NavigationStore = signalStore(
  withState(initialState),
  withMethods(navigationDataAdapterMethodsFactory),
  withMethods(navigationFeatureMethodsFactory),
  withMethods(navigationReductionMethodsFactory),
  withHooks(navigationHooksFactory),
);
